import React from 'react';
import clsx from 'clsx';

import { Icon, NavLink } from '../../../components';

type ContactNameProps = {
  id: string;
  name: string;
  className?: string;
  suffix?: React.ReactNode;
  withMessagesLink?: boolean;
  requires_human_input?: boolean;
};

const messagesElement = (
  <Icon icon="messages" tooltip="View messages" className="ml-sm shrink-0" />
);

const renderMessagesLink = (id?: string) => {
  if (!id) return null;

  return (
    <NavLink
      to={`/contacts_management/messages_history/${id}`}
      className="flex flex-row items-center text-text"
    >
      {messagesElement}
    </NavLink>
  );
};

type ContactNameType = React.FC<ContactNameProps> & {
  renderMessagesLink: typeof renderMessagesLink;
};

const ContactName: ContactNameType = ({
  id,
  name,
  suffix,
  className,
  withMessagesLink,
  requires_human_input,
}) => {
  const nameElement = (
    <>
      {!!requires_human_input && (
        <Icon
          icon="required"
          className="mr-sm"
          iconStyle="danger"
          tooltip="Requires human input"
        />
      )}
      <div
        className={clsx(
          'text-wrap max-w-[20rem]',
          requires_human_input && 'text-danger text-medium font-bold'
        )}
      >
        {name || <span className="italic font-bold">No Name</span>}
        {withMessagesLink && messagesElement}
        {suffix}
      </div>
    </>
  );

  return withMessagesLink ? (
    <NavLink
      to={`/contacts_management/messages_history/${id}`}
      className={clsx('flex flex-row items-center text-text', className)}
    >
      {nameElement}
    </NavLink>
  ) : (
    <div className={clsx('flex flex-row items-center text-text', className)}>
      {nameElement}
    </div>
  );
};

ContactName.renderMessagesLink = renderMessagesLink;

export default ContactName;
